import { useVoiceStore } from "@/stores";

/**
 * useVoice
 *
 * Thin component-facing wrapper over `voiceStore`, which owns the actual
 * `MediaRecorder` session — kept as a store (not component-local state) so
 * the `InputBar` mic button and the global push-to-talk hotkey
 * (`AppLayout`) share one recording rather than each tracking its own.
 */
export function useVoice() {
  const isRecording = useVoiceStore((s) => s.isRecording);
  const startRecording = useVoiceStore((s) => s.startRecording);
  const stopRecording = useVoiceStore((s) => s.stopRecording);
  return { isRecording, startRecording, stopRecording };
}
